"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelCheckboxSingle = _interopRequireDefault(require("./BrixelCheckboxSingle"));
var _reactRedux = require("react-redux");
var _translation = _interopRequireDefault(require("../../Translation/translation"));
var _BrixelInputMultiRange = _interopRequireDefault(require("../../hooks/component/BrixelInputMultiRange"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelInputMultiRangeSeparate = props => {
  const {
    className,
    disabled = false,
    formatLabel,
    label,
    lang = 'en',
    minLengthNum = 0,
    maxLengthNum = 1000,
    input,
    showSingleValCheck = false,
    step = 1,
    translations
  } = props;
  // CUSTOM HOOKS
  const roomRange = (0, _BrixelInputMultiRange.default)(minLengthNum, maxLengthNum);
  // STATE
  const minValueProps = minLengthNum;
  const maxValueProps = maxLengthNum;
  const minDeafultValue = (0, _get.default)(input, 'value.min', minValueProps);
  const maxDeafultValue = (0, _get.default)(input, 'value.max', maxValueProps);
  const [minVal, setMinVal] = (0, _react.useState)(minDeafultValue);
  const [maxVal, setMaxVal] = (0, _react.useState)(maxDeafultValue);
  const [minPosition, setMinPosition] = (0, _react.useState)(null);
  const [maxPosition, setMaxPosition] = (0, _react.useState)(null);
  const [minMargin, setMinMargin] = (0, _react.useState)(0);
  const [maxMargin, setMaxMargin] = (0, _react.useState)(0);
  const [singleVal, setSingleVal] = (0, _react.useState)(minDeafultValue === maxDeafultValue && showSingleValCheck);
  const minValRef = (0, _react.useRef)();
  const maxValRef = (0, _react.useRef)();
  const range = (0, _react.useRef)();
  const containerRange = (0, _react.useRef)();
  // Convert to percentage
  const getPercent = value => (value - minLengthNum) / (maxLengthNum - minLengthNum) * 100;
  // Set width of the range to decrease from the left side
  (0, _react.useEffect)(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(maxVal); // Preceding with '+' converts the value from type string to type number
      if (range.current) {
        setMinPosition(minPercent < 0 ? 0 : minPercent);
        setMaxPosition(maxPercent > 100 ? 100 : maxPercent);
        setMinMargin(24 * minPercent / 100);
        setMaxMargin(24 * maxPercent / 100);
        range.current.style.left = `${minPercent > 0 ? Math.round(minPercent) : 0}%`;
        let percWidth = Math.round(maxPercent) - Math.round(minPercent);
        percWidth = percWidth > 100 ? 100 : percWidth;
        percWidth = percWidth < 0 ? 0 : percWidth;
        range.current.style.width = `${percWidth > 90 ? percWidth - 1 : percWidth}%`;
      }
    } else {
      const minPercent = getPercent(minVal);
      if (range.current) {
        setMinPosition(minPercent < 0 ? 0 : minPercent);
        setMinMargin(24 * minPercent / 100);
        range.current.style.left = '0%';
        let percWidth = Math.round(minPercent);
        percWidth = percWidth > 100 ? 100 : percWidth;
        percWidth = percWidth < 0 ? 0 : percWidth;
        range.current.style.width = `${percWidth > 90 ? percWidth - 1 : percWidth}%`;
      }
    }
  }, [minVal, getPercent, maxVal, range, singleVal]);
  (0, _react.useEffect)(() => {
    if (input.value) {
      if ((0, _get.default)(input, 'value.min', minVal) !== minVal || (0, _get.default)(input, 'value.max', maxVal) !== maxVal) {
        roomRange.setRange((0, _get.default)(input, 'value.min', minVal), (0, _get.default)(input, 'value.max', maxVal));
      }
    }
  }, [(0, _get.default)(input, 'value.min', null), (0, _get.default)(input, 'value.max', null)]);
  (0, _react.useEffect)(() => {
    if (roomRange?.min || 0 >= minLengthNum && roomRange?.max || 0 <= maxLengthNum) {
      if (input.onChange) {
        input.onChange({
          min: roomRange.min,
          max: singleVal ? roomRange.min : roomRange.max
        });
      }
      let newMinval = minVal;
      let newMaxval = maxVal;
      if (roomRange.min !== null && roomRange.min !== undefined) newMinval = roomRange.min;
      if (roomRange.max !== null && roomRange.max !== undefined) newMaxval = roomRange.max;
      setMinVal(newMinval);
      setMaxVal(newMaxval);
      if (roomRange.min === roomRange.max) setSingleVal(true);
      if (roomRange.min && roomRange.max && roomRange.min === roomRange.max) setSingleVal(true);
    }
  }, [roomRange.min, roomRange.max]);
  const onChange = (val, type) => {
    if (!disabled) {
      if (type === 'min') {
        if (singleVal) {
          setMaxVal(maxLengthNum);
        }
        const newMin = parseInt(String(val), 10);
        if (!isNaN(newMin)) {
          roomRange.setRange(newMin, maxVal);
        }
      }
      if (type === 'max' && !singleVal) {
        const newMax = parseInt(String(val), 10);
        if (!isNaN(newMax)) {
          roomRange.setRange(minVal, newMax);
        }
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-multirange ${disabled ? 'disabled' : ''} ${className}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    "data-testid": "label",
    "aria-label": "label",
    className: "brixel-label mb-5"
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r w-perc-100",
    ref: containerRange
  }, /*#__PURE__*/_react.default.createElement("input", {
    "data-testid": "minValue",
    disabled: disabled,
    type: "range",
    min: minLengthNum,
    max: maxLengthNum,
    value: minVal || minLengthNum,
    step: step,
    ref: minValRef,
    onChange: e => onChange(e.target.value, 'min'),
    className: "thumb thumb--zindex-3"
  }), !singleVal && (/*#__PURE__*/_react.default.createElement("input", {
    "data-testid": "maxValue",
    disabled: disabled,
    type: "range",
    min: minLengthNum,
    max: maxLengthNum,
    value: maxVal || maxLengthNum,
    step: step,
    ref: maxValRef,
    onChange: e => onChange(e.target.value, 'max'),
    className: "thumb thumb--zindex-4"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "slider"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slider__track"
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: range,
    className: "slider__range"
  }), minPosition !== null && (maxPosition !== null || singleVal) && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "slider__left-value",
    style: {
      left: `${minPosition > 0 ? minPosition : 0}%`,
      marginLeft: -minMargin - 12
    }
  }, formatLabel ? formatLabel(minVal) : minVal), !singleVal && maxPosition && (/*#__PURE__*/_react.default.createElement("div", {
    className: "slider__right-value",
    style: {
      left: `${maxPosition > 100 ? 100 : maxPosition}%`,
      marginLeft: -maxMargin - 12
    }
  }, formatLabel ? formatLabel(maxVal) : maxVal)))))), showSingleValCheck && (/*#__PURE__*/_react.default.createElement(_BrixelCheckboxSingle.default, {
    "data-testid": "singleCheckbox",
    className: "mt-6",
    input: {
      name: 'singleCheckbox',
      onChange: val => {
        setMaxVal(minVal);
        setSingleVal(val !== false);
      },
      value: Boolean(singleVal)
    },
    options: {
      label: (0, _translation.default)('Select a specific value', lang, null, translations),
      value: true,
      icon: 'alert'
    }
  })));
};
const mapStateToProps = state => ({
  translations: (0, _get.default)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelInputMultiRangeSeparate);